module.exports = __webpack_public_path__ + "static/media/preview.e658693d.png";